import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const dict = {
  pt: {
    app: "Nafe Logistica",
    tagline: "Sistema de Gestão Operacional, Logística e Financeira",
    login: "Entrar",
    logout: "Sair",
    email: "E-mail",
    password: "Senha",
    sign_in: "Acessar painel",
    welcome_back: "Bem-vindo de volta",
    sign_in_subtitle: "Entre com suas credenciais corporativas",
    invalid: "Credenciais inválidas",
    nav_dashboard: "Painel Executivo",
    nav_documents: "Central de Documentos",
    nav_operational: "Central Operacional",
    nav_imports: "Importação / Homologação",
    nav_bipagem: "Bipagem de AR",
    nav_email_ingest: "E-mail cartório",
    nav_tracking: "Rastreio ao vivo",
    nav_occurrences: "Catálogo ocorrências",
    nav_routes: "Gestão de Rotas",
    nav_evidences: "Evidências",
    nav_audit: "Auditoria",
    nav_financial: "Financeiro",
    nav_commissions: "Comissões",
    nav_productivity: "Produtividade",
    nav_goals: "Metas de entrega",
    nav_notifications: "Notificações",
    nav_reports: "Relatórios",
    nav_portal: "Portal do Cliente",
    nav_deliverer: "App Entregador",
    nav_service_orders: "Ordem de Serviço",
    nav_tenants: "Cartórios",
    nav_sectors: "Setores",
    nav_users: "Usuários",
    nav_webhooks: "Webhooks",
    nav_security: "Segurança",
    nav_settings: "Configurações",
    section_operations: "Operações",
    section_tracking: "Rastreio & Provas",
    section_finance: "Financeiro",
    section_governance: "Governança",
    section_system: "Sistema",
    expand_menu: "Expandir menu",
    collapse_menu: "Recolher menu",
    help: "Ajuda",
    help_got_it: "Entendi",
    kpi_received_today: "Recebidos hoje",
    kpi_in_processing: "Em processamento",
    kpi_in_route: "Em rota",
    kpi_delivered: "Entregues",
    kpi_returned: "Devolvidos",
    kpi_pending: "Pendentes",
    kpi_success_rate: "Taxa de sucesso",
    kpi_total: "Total acompanhado",
    chart_daily: "Entregas no período",
    chart_region: "Entregas por região",
    chart_region_neighborhood: "Entregas por bairro",
    chart_filters: "Filtros dos gráficos",
    chart_filters_hint: "Período, região e status valem para os dois gráficos abaixo. Os KPIs continuam em tempo real.",
    chart_period_7d: "7 dias",
    chart_period_30d: "30 dias",
    chart_period_month: "Mês",
    chart_period_semester: "Semestre",
    chart_period_year: "Ano",
    chart_period_custom: "Personalizado",
    chart_all_regions: "Todas as regiões",
    chart_all_statuses: "Todos os status",
    chart_custom_range: "Intervalo",
    chart_from: "De",
    chart_to: "Até",
    chart_daily_received: "Objeto Recebido",
    chart_daily_in_route: "Em Rota de Entrega",
    chart_daily_attempted: "Tentativa de Entrega",
    chart_daily_delivered: "Entregues",
    chart_daily_canceled: "Cancelados",
    chart_daily_returned: "Devolvidos",
    alerts: "Alertas inteligentes",
    no_alerts: "Sem alertas no momento.",
    no_data: "Sem dados neste filtro.",
    status_received: "Objeto Recebido",
    status_out_for_delivery: "Em Rota de Entrega",
    status_attempted: "Tentativa de Entrega",
    status_delivered: "Entregue",
    status_returned: "Devolvido",
    status_canceled: "Cancelado",
    search_placeholder: "Buscar documentos, CPF/CNPJ, endereço, cartório...",
    new_document: "Novo documento",
    import_csv: "Importar CSV",
    import_status_pending: "Pendente",
    import_status_approved: "Aprovado",
    import_status_rejected: "Rejeitado",
    import_status_partial: "Parcial",
    import_status_invalid: "Inválido",
    export: "Exportar",
    filters: "Filtros",
    actions: "Ações",
    view_list: "Lista",
    view_kanban: "Kanban",
    view_cards: "Cards",
    recipient: "Destinatário",
    address: "Endereço",
    city: "Cidade",
    status: "Status",
    deliverer: "Entregador",
    created: "Criado",
    updated: "Atualizado",
    document_number: "Número",
    notary: "Cartório",
    open: "Abrir",
    summary: "Resumo",
    history: "Histórico",
    evidences: "Evidências",
    audit_tab: "Auditoria",
    finance_balance: "Saldo realizado",
    receivable: "A receber",
    payable: "A pagar",
    pending: "Pendente",
    paid: "Pago",
    add_entry: "Lançar",
    finance_party_receivable: "Cliente",
    finance_party_payable: "Fornecedor",
    finance_party_hint_receivable: "Quem vai pagar este recebível",
    finance_party_hint_payable: "Quem vai receber este pagamento",
    finance_installments_hint: "O valor total será dividido em parcelas mensais a partir do 1º vencimento",
    description: "Descrição",
    amount: "Valor",
    due_date: "Vencimento",
    kind: "Tipo",
    save: "Salvar",
    cancel: "Cancelar",
    mark_paid: "Baixar",
    commissions_pending: "Comissões pendentes",
    commissions_paid: "Comissões pagas",
    commissions_entries: "lançamentos",
    commissions_list: "Lançamentos",
    commissions_pay_pending: "Baixar pendentes",
    commissions_paid_ok: "Comissão baixada. Conta a pagar gerada no Financeiro.",
    commissions_paid_failed: "Falha ao baixar comissão",
    commissions_paid_bulk: "{count} comissão(ões) baixada(s) e lançadas em Contas a pagar",
    commissions_city_title: "Objetos por cidade",
    commissions_city_hint: "A cidade usada é a do cadastro do documento (campo city), não a da entrega. As primeiras entregas do mês entram no fixo; o excedente gera comissão.",
    commissions_city_source: "As cidades da lista vêm dos documentos já cadastrados. Escolha a cidade, o formato (endereço ou documento), o valor e o fixo mínimo.",
    commissions_city_rules: "Regras por cidade",
    commissions_city_add: "Adicionar cidade",
    commissions_city_remove: "Remover cidade",
    commissions_city_saved: "Regras de comissão salvas",
    commissions_city_save_failed: "Falha ao salvar regras de comissão",
    commissions_city_no_documents: "Nenhuma cidade encontrada nos documentos. Cadastre ou importe documentos com o campo cidade preenchido.",
    commissions_city_indaiatuba: "R$ 0,40 por endereço. Se no mesmo endereço houver 10 documentos, conta como 1 entrega.",
    commissions_city_salto: "R$ 0,60 por documento. Se no mesmo endereço houver 10 documentos, contam 10 entregas.",
    commissions_city_mode_address: "por endereço",
    commissions_city_mode_document: "por documento",
    commissions_city_fixed: "Fixo",
    commissions_city_units: "Apurados",
    commissions_city_excess: "Excedente",
    commissions_city_documents: "Documentos",
    commissions_city_basis: "Base",
    commissions_city_empty: "Nenhum objeto entregue nas cidades configuradas neste período.",
    commissions_period: "Período",
    accumulated: "Acumulado",
    deliveries_today: "Entregas hoje",
    my_route: "Minha rota",
    register_occurrence: "Registrar ocorrência",
    navigate: "Navegar",
    finalize: "Finalizar entrega",
    capture_photo: "Anexar foto ou arquivo",
    capture_signature: "Anexar assinatura",
    capture_ar: "Anexar AR",
    recipient_name: "Nome do recebedor",
    notes: "Observações",
    submit: "Confirmar",
    outcome_delivered: "Entregue",
    outcome_attempted: "Ocorrência",
    audit_user: "Usuário",
    audit_action: "Ação",
    audit_module: "Módulo",
    audit_when: "Quando",
    audit_entity: "Entidade",
    portal_title: "Portal do Cliente",
    portal_subtitle: "Acompanhe seus documentos em tempo real",
    portal_readonly: "Somente visualização",
    tracking_delivery: "Rastreamento de entregas",
    document_singular: "documento",
    documents_count_label: "documentos",
    pagination_page: "Página",
    pagination_of: "de",
    pagination_prev: "Anterior",
    pagination_next: "Próxima",
    pagination_per_page: "{n} por página",
    search: "Buscar",
    pill_delivered: "Entregue",
    pill_returned: "Devolvido",
    pill_in_transit: "Em trânsito",
    pill_checking: "Verificando",
    main_info: "Informações principais",
    tab_order_details: "Detalhes",
    tab_driver_info: "Entregador",
    live_on_map: "Em campo",
    live_updated: "Atualizado {when}",
    live_now: "agora",
    live_seconds_ago: "há {n} s",
    live_minutes_ago: "há {n} min",
    live_no_gps: "Sem GPS do entregador no momento",
    live_open_tracking: "Rastreio ao vivo",
    live_destination: "Destino",
    tab_attachments: "Anexos",
    attachments_empty: "Nenhum anexo neste documento.",
    attachments_add: "Adicionar anexo",
    attachments_file: "Arquivo",
    attachments_kind: "Tipo",
    attachments_upload: "Enviar anexo",
    attachments_upload_ok: "Anexo enviado",
    attachments_upload_fail: "Falha ao enviar anexo",
    attachments_view: "Visualizar",
    attachments_by: "Enviado por",
    timeline_loading: "Carregando histórico...",
    timeline_empty: "Nenhum registro no histórico.",
    timeline_occurrence: "Ocorrência",
    timeline_evidence: "Evidência",
    timeline_audit: "Auditoria",
    timeline_note_status_changed: "Status alterado para {status}",
    timeline_note_occurrence: "Ocorrência: {outcome}",
    timeline_note_merged: "Unificado no documento {label}",
    timeline_note_barcode_link: "Código de barras vinculado",
    timeline_note_barcode_unlink: "Código de barras desvinculado",
    timeline_note_received: "Documento recebido",
    timeline_note_deliverer_linked: "Entregador vinculado",
    timeline_note_deliverer_unlinked: "Entregador desvinculado",
    timeline_note_received_seed: "Documento recebido (seed)",
    timeline_note_csv: "Importado via CSV",
    timeline_note_homologated: "Importado (homologado)",
    timeline_note_intimacao: "Intimação recebida",
    timeline_note_homologation_rejected: "Homologação rejeitada",
    timeline_note_deliverer_linked: "Entregador vinculado",
    timeline_note_manual_assoc: "Associação manual",
    timeline_note_delivery_done: "Entrega concluída",
    timeline_note_absent: "Destinatário ausente",
    timeline_note_deliverer_linked: "Entregador vinculado",
    evidence_kind_photo: "Foto",
    evidence_kind_signature: "Assinatura",
    evidence_kind_ar: "AR",
    evidence_kind_receipt: "Comprovante",
    evidence_kind_document: "Documento",
    audit_action_barcode_link: "Vínculo de código de barras",
    audit_action_create: "Criação",
    audit_action_update: "Atualização",
    audit_action_archive: "Arquivamento",
    audit_action_associate: "Associação de protocolos",
    audit_action_login: "Login",
    audit_action_group_save: "Grupo salvo",
    audit_action_homologate_approve: "Homologação aprovada",
    audit_action_homologate_reject: "Homologação rejeitada",
    audit_action_approve: "Aprovação",
    audit_action_bulk_update: "Atualização em lote",
    audit_action_assign_deliverer: "Vínculo de entregador",
    audit_action_lgpd_export: "Exportação LGPD",
    audit_action_lgpd_forget: "Direito ao esquecimento",
    audit_all: "Todos",
    audit_mod_auth: "Autenticação",
    audit_mod_documents: "Documentos",
    audit_mod_evidences: "Evidências",
    audit_mod_occurrences: "Ocorrências",
    audit_mod_finance: "Financeiro",
    audit_mod_routes: "Rotas",
    audit_mod_commissions: "Comissões",
    audit_mod_tenants: "Cartórios",
    audit_mod_sectors: "Setores",
    audit_mod_webhooks: "Webhooks",
    audit_mod_push: "Push",
    audit_mod_users: "Usuários",
    audit_mod_imports: "Importação",
    audit_mod_protocols: "Protocolos",
    audit_mod_service_orders: "Ordens de Serviço",
    audit_mod_security: "Segurança",
    current_location: "Localização atual",
    speed: "Velocidade",
    kilometers_left: "Km restantes",
    last_stop: "Última parada",
    hours_ago: "há 2 horas",
    label_recipient: "Destinatário",
    label_address: "Endereço",
    label_notary: "Cartório",
    label_created: "Criado",
    label_name: "Nome",
    label_cpf: "CPF",
    label_cnpj: "CNPJ",
    label_phone: "Telefone",
    new_short: "Novo",
    no_deliverer: "Sem entregador",
    select_delivery: "Selecione uma entrega à esquerda",
    no_documents: "Nenhum documento",
    order_id: "Pedido",
    dlg_new_document: "Novo documento",
    dlg_protocol_number: "Número Protocolo",
    dlg_debtor: "Nome do devedor",
    dlg_tax_id: "CPF/CNPJ",
    dlg_recipient: "Destinatário",
    dlg_cpf: "CPF",
    dlg_address: "Endereço",
    dlg_neighborhood: "Bairro",
    dlg_city: "Cidade",
    dlg_state: "UF",
    dlg_zip: "CEP",
    cep_lookup_fail: "Não foi possível consultar o CEP",
    dlg_notary: "Cartório",
    dlg_select_notary: "Selecionar cartório",
    doc_phase: "Fase",
    doc_sector: "Setor",
    doc_sector_none: "Sem setor",
    dlg_create: "Criar",
    doc_created: "Documento criado",
    doc_create_failed: "Falha ao criar documento",
    doc_edit: "Editar documento",
    doc_updated: "Documento atualizado",
    doc_update_failed: "Falha ao atualizar documento",
    dlg_edit_document: "Editar documento",
    dlg_save: "Salvar",
    download: "Baixar",
    light: "Claro",
    dark: "Escuro",
    language: "Idioma",
    create: "Criar",
    delete: "Excluir",
    confirm_delete: "Tem certeza?",
    drag_drop_hint: "Arraste cartões entre colunas ou clique para ver detalhes",
    canceled_move_blocked: "Intimação cancelada. Somente o administrador pode movê-la de coluna.",
    click_for_details: "Clique para detalhes",
    new_route: "Nova rota",
    assign_deliverer: "Vincular entregador",
    docs_deliverer_link: "Vínculo entregador",
    docs_deliverer_all: "Todos os vínculos",
    docs_select_page: "Selecionar página",
    docs_select_filtered: "Selecionar filtrados",
    docs_clear_selection: "Limpar seleção",
    docs_selected_count: "{n} selecionados",
    docs_link_selected: "Vincular selecionados",
    docs_link_ok: "Vínculo atualizado",
    deliverer_assigned_ok: "Entregador vinculado ao documento",
    bipagem_assign_title: "Vincular entregador",
    bipagem_assign_desc: "Escolha o setor e depois o entregador. Troque a seleção quando for o lote seguinte.",
    bipagem_select_first: "Selecione o entregador antes de bipar.",
    bipagem_now_scanning: "Bipagens a partir de agora vão para",
    bipagem_now_sector: "Setor da sessão:",
    bipagem_intro: "Escolha o setor e depois o entregador. Sem setor, a lista mostra todos os entregadores.",
    bipagem_session_sector: "Setor desta sessão",
    bipagem_sector_all: "Sem setor: todos os entregadores. Não atribuído continua disponível.",
    bipagem_sector_filtered: "Entregadores do setor {name}. Não atribuído continua disponível.",
    bipagem_assign_confirm: "Vincular entregador",
    bipagem_assign_ok: "Entregador vinculado",
    bipagem_session_deliverer: "Entregador desta sessão",
    bipagem_no_session_deliverer: "Nenhum entregador definido",
    bipagem_list_count: "Objetos neste lote",
    bipagem_change_deliverer: "Trocar entregador",
    bipagem_just_scanned: "Documento bipado",
    bipagem_fix_deliverer: "Corrigir entregador",
    bipagem_fix_selected: "Corrigir selecionados",
    bipagem_fix_ok: "Entregador corrigido",
    bipagem_fix_none: "Selecione ao menos uma bipagem para corrigir",
    deliverer_assign_fail: "Falha ao vincular entregador",
    region: "Região",
    distance: "Distância",
    estimated_time: "Tempo estimado",
    photos: "Fotos",
    signatures: "Assinaturas",
    ar_documents: "ARs",
    receipts: "Comprovantes",
    geolocation: "Geolocalização",
    by_period: "Por período",
    by_deliverer: "Por entregador",
    by_document: "Por documento",
    report_documents: "Documentos",
    report_finance: "Financeiro",
    report_commissions: "Comissões",
    report_audit: "Auditoria",
    report_choose_area: "Escolha a área",
    report_choose_report: "Escolha o relatório",
    report_area_operation: "Operação",
    report_area_operation_desc: "Posição do dia, ocorrências e devoluções.",
    report_area_management: "Gestão",
    report_area_management_desc: "Produção, produtividade, ciclo e metas.",
    report_area_finance: "Financeiro",
    report_area_finance_desc: "Comissões, contas e ordens de serviço.",
    report_area_legal: "Jurídico",
    report_area_legal_desc: "Prova de entrega e trilha de auditoria.",
    report_operational_position: "Posição operacional",
    report_operational_position_desc: "Status, aging e documentos parados.",
    report_occurrences: "Ocorrências",
    report_occurrences_desc: "Entregue, tentativa e devolvido no período.",
    report_returns: "Devoluções por motivo",
    report_returns_desc: "Motivos de devolução por cidade e cartório.",
    report_production: "Produção por cartório",
    report_production_desc: "Volume importado, entregue e devolvido.",
    report_productivity: "Produtividade do entregador",
    report_productivity_desc: "Ranking, taxa de sucesso e volume.",
    report_sla: "Ciclo e SLA",
    report_sla_desc: "Tempo received → delivered por cidade.",
    report_goals: "Metas vs realizado",
    report_goals_desc: "Atingimento de metas no período.",
    report_commission_closing: "Fechamento de comissões",
    report_commission_closing_desc: "Folha mensal por entregador e cidade.",
    report_finance_aging: "Contas a receber e pagar",
    report_finance_aging_desc: "Vencidos, a vencer e por parte.",
    report_service_orders: "Ordens de serviço",
    report_service_orders_desc: "OS por motorista, km, valor e status.",
    report_evidence_coverage: "Prova de entrega",
    report_evidence_coverage_desc: "Evidências, GPS e entregas sem prova.",
    report_audit_trail: "Auditoria",
    report_audit_trail_desc: "Trilha imutável de ações críticas.",
    report_page_subtitle: "Escolha a área, o relatório e exporte em CSV, Excel ou PDF.",
    report_generation_pending: "A geração deste relatório será ligada na próxima etapa.",
    generate: "Gerar",
    users_subtitle: "Cadastre, edite e altere usuários em lote. Vincule entregador ao operador e cartórios ao operador.",
    users_new: "Novo usuário",
    users_role: "Perfil",
    users_status: "Status",
    users_active: "Ativo",
    users_inactive: "Inativo",
    users_empty: "Nenhum usuário cadastrado",
    users_selected: "{count} selecionado(s)",
    users_bulk_role: "Alterar perfil",
    users_select_role: "Selecionar perfil",
    users_apply_role: "Aplicar perfil",
    users_activate: "Ativar selecionados",
    users_deactivate: "Desativar selecionados",
    users_clear_selection: "Limpar seleção",
    users_you: "você",
    users_created: "Usuário criado",
    users_create_failed: "Falha ao criar usuário",
    users_bulk_updated: "{count} usuário(s) atualizado(s)",
    users_bulk_failed: "Falha na alteração em lote",
    users_select_tenant: "Selecionar cartório",
    users_tenants: "Cartórios",
    users_select_tenants: "Selecione um ou mais cartórios",
    users_operator: "Operador",
    users_select_operator: "Selecionar operador",
    users_no_operators: "Cadastre um operador antes de vincular o entregador",
    users_create_btn: "Criar usuário",
    users_edit: "Editar usuário",
    users_save: "Salvar alterações",
    users_updated: "Usuário atualizado",
    users_update_failed: "Falha ao atualizar usuário",
    users_password_optional: "Deixe em branco para manter a senha atual",
    users_password_required: "Informe uma senha para o novo usuário",
    users_bulk_apply: "Aplicar alterações",
    users_bulk_nothing: "Selecione ao menos um campo para alterar",
    users_keep: "Manter",
    tenants_subtitle: "Cada cartório opera de forma isolada.",
    tenants_new: "Novo cartório",
    tenants_edit: "Editar cartório",
    tenants_create_btn: "Criar cartório",
    tenants_contact_email: "E-mail de contato",
    tenants_city_hint: "Usada para vincular o cartório automaticamente na importação",
    tenants_created: "Cartório criado",
    tenants_updated: "Cartório atualizado",
    tenants_create_failed: "Falha ao criar cartório",
    tenants_update_failed: "Falha ao atualizar cartório",
    sectors_subtitle: "Cada cartório tem seus setores. O nome do setor é livre; cartórios e entregadores vêm dos cadastros existentes.",
    sectors_new: "Novo setor",
    sectors_add: "Adicionar setor",
    sectors_edit: "Editar setor",
    sectors_create_btn: "Criar setor",
    sectors_name: "Nome do setor",
    sectors_name_placeholder: "Ex.: Centro, Morada do Sol",
    sectors_deliverers: "Entregadores",
    sectors_filter_deliverers: "Buscar entregador",
    sectors_deliverer_hint: "O mesmo entregador pode estar em vários setores.",
    sectors_selected: "{count} selecionado(s)",
    sectors_no_deliverers: "Nenhum entregador cadastrado. Crie em Usuários.",
    sectors_no_tenants: "Nenhum cartório cadastrado. Crie em Cartórios.",
    sectors_empty: "Nenhum setor neste cartório.",
    sectors_created: "Setor criado",
    sectors_updated: "Setor atualizado",
    sectors_deleted: "Setor excluído",
    sectors_save_failed: "Falha ao salvar setor",
    sectors_delete: "Excluir",
    sectors_delete_title: "Excluir setor",
    sectors_delete_desc: "Os vínculos dos entregadores com este setor também serão removidos.",
    sectors_search: "Buscar cartório, setor ou entregador",
    sectors_count: "{count} setor(es)",
    sectors_none_linked: "Nenhum entregador vinculado",
    sectors_no_match: "Nenhum resultado",
    loading: "Carregando...",
    saving: "Salvando...",
    so_subtitle: "Cadastro de Ordem de Serviço de Transporte de Carga",
    so_title_transport: "Ordem de Serviço de Transporte de Carga",
    so_section_order: "Dados da Ordem de Serviço",
    so_section_service: "Dados do Serviço Executado",
    so_section_complement: "Dados Complementares",
    so_numero_os: "Número da OS:",
    so_numero_os_auto: "Gerado automaticamente ao salvar",
    so_datetime: "Data e Horário do Serviço:",
    so_cliente_pagador: "Cliente pagador:",
    so_cliente_tax_id: "CNPJ/CPF do Cliente:",
    so_coleta: "Endereço de Coleta {n}:",
    so_coleta01: "Endereço de Coleta 01:",
    so_coleta02: "Endereço de Coleta 02:",
    so_coleta03: "Endereço de Coleta 03:",
    so_add_coleta: "Adicionar endereço de coleta",
    so_remove_coleta: "Remover endereço de coleta",
    so_mercadoria: "Mercadoria:",
    so_entrega: "Endereço de Entrega {n}:",
    so_add_entrega: "Adicionar endereço de entrega",
    so_remove_entrega: "Remover endereço de entrega",
    so_km_inicial: "Km inicial:",
    so_km_final: "Km final:",
    so_km_total: "Km total:",
    so_valor_frete: "Valor do Frete:",
    so_valor_frete_admin: "Calculado automaticamente",
    so_valor_frete_only_admin: "Somente o administrador pode alterar este valor",
    so_placa: "Placa do Veículo:",
    so_motorista: "Nome do Motorista:",
    so_observacoes: "Observações",
    so_save: "Salvar ordem de serviço",
    so_new: "Nova OS",
    so_select: "Selecionar OS",
    so_created: "Ordem de serviço criada",
    so_updated: "Ordem de serviço atualizada",
    so_deliverer: "Entregador:",
    so_deliverer_select: "Selecionar entregador",
    so_deliverer_none: "Não atribuído",
    so_created_pending: "Ordem enviada para aprovação do administrador",
    so_deliverer_pending_msg: "Esta ordem foi enviada e não pode mais ser editada. Aguarde o administrador definir o valor do frete e aprovar.",
    so_history_title: "Histórico de Ordens de Serviço",
    so_history_empty: "Nenhuma ordem de serviço encontrada",
    so_filter_all: "Todos os status",
    so_status_pendente_aprovacao: "Aguardando aprovação",
    so_status_aprovada: "Aprovada",
    so_status_cancelada: "Cancelada",
    so_approve: "Enviar e Aprovar",
    so_approved: "Ordem aprovada e lançada em Contas a Receber",
    so_frete_required: "Informe o valor do frete",
    so_export_ok: "Exportação concluída",
    so_timeline: "Histórico da OS",
    so_action_criada: "Criada",
    so_action_editada: "Editada pelo administrador",
    so_action_aprovada: "Aprovada",
    role_admin: "Administrador",
    role_operator: "Operador",
    role_deliverer: "Entregador",
    role_client: "Cliente",
  },
  en: {
    app: "Nafe Logistica",
    tagline: "Operations, Logistics & Finance Platform",
    login: "Sign in",
    logout: "Sign out",
    email: "Email",
    password: "Password",
    sign_in: "Access dashboard",
    welcome_back: "Welcome back",
    sign_in_subtitle: "Sign in with your corporate credentials",
    invalid: "Invalid credentials",
    nav_dashboard: "Executive Dashboard",
    nav_documents: "Document Center",
    nav_operational: "Operations",
    nav_imports: "Import / Homologation",
    nav_bipagem: "AR barcode scan",
    nav_email_ingest: "Notary email",
    nav_tracking: "Live tracking",
    nav_occurrences: "Occurrence catalog",
    nav_routes: "Routes",
    nav_evidences: "Evidence",
    nav_audit: "Audit",
    nav_financial: "Financial",
    nav_commissions: "Commissions",
    nav_productivity: "Productivity",
    nav_goals: "Delivery goals",
    nav_notifications: "Notifications",
    nav_reports: "Reports",
    nav_portal: "Client Portal",
    nav_deliverer: "Deliverer App",
    nav_service_orders: "Service Order",
    nav_tenants: "Tenants",
    nav_sectors: "Sectors",
    nav_users: "Users",
    nav_webhooks: "Webhooks",
    nav_security: "Security",
    nav_settings: "Settings",
    section_operations: "Operations",
    section_tracking: "Tracking & Proof",
    section_finance: "Finance",
    section_governance: "Governance",
    section_system: "System",
    expand_menu: "Expand menu",
    collapse_menu: "Collapse menu",
    help: "? Help",
    help_got_it: "Got it",
    kpi_received_today: "Received today",
    kpi_in_processing: "Processing",
    kpi_in_route: "In route",
    kpi_delivered: "Delivered",
    kpi_returned: "Returned",
    kpi_pending: "Pending",
    kpi_success_rate: "Success rate",
    kpi_total: "Total tracked",
    chart_daily: "Deliveries in the period",
    chart_region: "Deliveries by region",
    chart_region_neighborhood: "Deliveries by neighborhood",
    chart_filters: "Chart filters",
    chart_filters_hint: "Period, region and status apply to the two charts below. KPIs stay real-time.",
    chart_period_7d: "7 days",
    chart_period_30d: "30 days",
    chart_period_month: "Month",
    chart_period_semester: "Semester",
    chart_period_year: "Year",
    chart_period_custom: "Custom",
    chart_all_regions: "All regions",
    chart_all_statuses: "All statuses",
    chart_custom_range: "Range",
    chart_from: "From",
    chart_to: "To",
    chart_daily_received: "Object Received",
    chart_daily_in_route: "In route of delivery",
    chart_daily_attempted: "Delivery Attempt",
    chart_daily_delivered: "Delivered",
    chart_daily_canceled: "Canceled",
    chart_daily_returned: "Returned",
    alerts: "Smart alerts",
    no_alerts: "No alerts at the moment.",
    no_data: "No data for this filter.",
    status_received: "Object Received",
    status_out_for_delivery: "In Route of Delivery",
    status_attempted: "Delivery Attempt",
    status_delivered: "Delivered",
    status_returned: "Returned",
    status_canceled: "Canceled",
    search_placeholder: "Search documents, CPF/CNPJ, address, notary...",
    new_document: "New document",
    import_csv: "Import CSV",
    import_status_pending: "Pending",
    import_status_approved: "Approved",
    import_status_rejected: "Rejected",
    import_status_partial: "Partial",
    import_status_invalid: "Invalid",
    export: "Export",
    filters: "Filters",
    actions: "Actions",
    view_list: "List",
    view_kanban: "Kanban",
    view_cards: "Cards",
    recipient: "Recipient",
    address: "Address",
    city: "City",
    status: "Status",
    deliverer: "Deliverer",
    created: "Created",
    updated: "Updated",
    document_number: "Number",
    notary: "Notary",
    open: "Open",
    summary: "Summary",
    history: "History",
    evidences: "Evidence",
    audit_tab: "Audit",
    finance_balance: "Realized balance",
    receivable: "Receivable",
    payable: "Payable",
    pending: "Pending",
    paid: "Paid",
    add_entry: "Add entry",
    finance_party_receivable: "Customer",
    finance_party_payable: "Vendor",
    finance_party_hint_receivable: "Who will pay this receivable",
    finance_party_hint_payable: "Who will receive this payment",
    finance_installments_hint: "The total amount will be split into monthly installments from the first due date",
    description: "Description",
    amount: "Amount",
    due_date: "Due date",
    kind: "Type",
    save: "Save",
    cancel: "Cancel",
    mark_paid: "Mark paid",
    commissions_pending: "Pending commissions",
    commissions_paid: "Paid commissions",
    commissions_entries: "entries",
    commissions_list: "Entries",
    commissions_pay_pending: "Settle pending",
    commissions_paid_ok: "Commission settled. Payable created in Finance.",
    commissions_paid_failed: "Failed to settle commission",
    commissions_paid_bulk: "{count} commission(s) settled and posted as payables",
    commissions_city_title: "Document commissions by city",
    commissions_city_hint: "City comes from the document record (city field), not from the delivery event. The first deliveries of the month are included in the fixed quota; anything above that earns commission.",
    commissions_city_source: "Cities in the list come from registered documents. Choose the city, billing basis (address or document), rate and fixed quota.",
    commissions_city_rules: "Rules by city",
    commissions_city_add: "Add city",
    commissions_city_remove: "Remove city",
    commissions_city_saved: "Commission rules saved",
    commissions_city_save_failed: "Failed to save commission rules",
    commissions_city_no_documents: "No cities found in documents. Register or import documents with the city field filled in.",
    commissions_city_indaiatuba: "R$ 0.40 per address. 10 documents at the same address count as 1 delivery.",
    commissions_city_salto: "R$ 0.60 per document. 10 documents at the same address count as 10 deliveries.",
    commissions_city_mode_address: "per address",
    commissions_city_mode_document: "per document",
    commissions_city_fixed: "Fixed quota",
    commissions_city_units: "Counted",
    commissions_city_excess: "Excess",
    commissions_city_documents: "Documents",
    commissions_city_basis: "Basis",
    commissions_city_empty: "No objects delivered in the configured cities in this period.",
    commissions_period: "Period",
    accumulated: "Accumulated",
    deliveries_today: "Today's deliveries",
    my_route: "My route",
    register_occurrence: "Register attempt",
    navigate: "Navigate",
    finalize: "Finalize delivery",
    capture_photo: "Attach photo or file",
    capture_signature: "Attach signature",
    capture_ar: "Attach AR",
    recipient_name: "Recipient name",
    notes: "Notes",
    submit: "Submit",
    outcome_delivered: "Delivered",
    outcome_attempted: "Occurrence",
    audit_user: "User",
    audit_action: "Action",
    audit_module: "Module",
    audit_when: "When",
    audit_entity: "Entity",
    portal_title: "Client Portal",
    portal_subtitle: "Track your documents in real-time",
    portal_readonly: "View only",
    tracking_delivery: "Delivery tracking",
    document_singular: "document",
    documents_count_label: "documents",
    pagination_page: "Page",
    pagination_of: "of",
    pagination_prev: "Previous",
    pagination_next: "Next",
    pagination_per_page: "{n} per page",
    search: "Search",
    pill_delivered: "Delivered",
    pill_returned: "Returned",
    pill_in_transit: "In Transit",
    pill_checking: "Checking",
    main_info: "Main info",
    tab_order_details: "Order details",
    tab_driver_info: "Deliverer",
    live_on_map: "In the field",
    live_updated: "Updated {when}",
    live_now: "just now",
    live_seconds_ago: "{n}s ago",
    live_minutes_ago: "{n} min ago",
    live_no_gps: "No deliverer GPS right now",
    live_open_tracking: "Live tracking",
    live_destination: "Destination",
    tab_attachments: "Attachments",
    attachments_empty: "No attachments for this document.",
    attachments_add: "Add attachment",
    attachments_file: "File",
    attachments_kind: "Type",
    attachments_upload: "Upload attachment",
    attachments_upload_ok: "Attachment uploaded",
    attachments_upload_fail: "Failed to upload attachment",
    attachments_view: "View",
    attachments_by: "Uploaded by",
    timeline_loading: "Loading timeline...",
    timeline_empty: "No timeline records.",
    timeline_occurrence: "Occurrence",
    timeline_evidence: "Evidence",
    timeline_audit: "Audit",
    timeline_note_status_changed: "Status changed to {status}",
    timeline_note_occurrence: "Occurrence: {outcome}",
    timeline_note_merged: "Merged into document {label}",
    timeline_note_barcode_link: "Barcode linked",
    timeline_note_barcode_unlink: "Barcode unlinked",
    timeline_note_received: "Document received",
    timeline_note_deliverer_linked: "Deliverer linked",
    timeline_note_deliverer_unlinked: "Deliverer unlinked",
    timeline_note_received_seed: "Document received (seed)",
    timeline_note_csv: "Imported via CSV",
    timeline_note_homologated: "Imported (homologated)",
    timeline_note_intimacao: "Intimation received",
    timeline_note_homologation_rejected: "Homologation rejected",
    timeline_note_deliverer_linked: "Deliverer assigned",
    timeline_note_manual_assoc: "Manual association",
    timeline_note_delivery_done: "Delivery completed",
    timeline_note_absent: "Recipient absent",
    timeline_note_deliverer_linked: "Deliverer assigned",
    evidence_kind_photo: "Photo",
    evidence_kind_signature: "Signature",
    evidence_kind_ar: "AR",
    evidence_kind_receipt: "Receipt",
    evidence_kind_document: "Document",
    audit_action_barcode_link: "Barcode link",
    audit_action_create: "Create",
    audit_action_update: "Update",
    audit_action_archive: "Archive",
    audit_action_associate: "Protocol association",
    audit_action_login: "Login",
    audit_action_group_save: "Group saved",
    audit_action_homologate_approve: "Homologation approved",
    audit_action_homologate_reject: "Homologation rejected",
    audit_action_approve: "Approval",
    audit_action_bulk_update: "Bulk update",
    audit_action_assign_deliverer: "Deliverer link",
    audit_action_lgpd_export: "LGPD export",
    audit_action_lgpd_forget: "Right to be forgotten",
    audit_all: "All",
    audit_mod_auth: "Authentication",
    audit_mod_documents: "Documents",
    audit_mod_evidences: "Evidence",
    audit_mod_occurrences: "Occurrences",
    audit_mod_finance: "Financial",
    audit_mod_routes: "Routes",
    audit_mod_commissions: "Commissions",
    audit_mod_tenants: "Tenants",
    audit_mod_sectors: "Sectors",
    audit_mod_webhooks: "Webhooks",
    audit_mod_push: "Push",
    audit_mod_users: "Users",
    audit_mod_imports: "Import",
    audit_mod_protocols: "Protocols",
    audit_mod_service_orders: "Service Orders",
    audit_mod_security: "Security",
    current_location: "Current location",
    speed: "Speed",
    kilometers_left: "Kilometers left",
    last_stop: "Last stop",
    hours_ago: "2 hours ago",
    label_recipient: "Recipient",
    label_address: "Address",
    label_notary: "Notary",
    label_created: "Created",
    label_name: "Name",
    label_cpf: "ID",
    label_cnpj: "CNPJ",
    label_phone: "Phone",
    new_short: "New",
    no_deliverer: "No deliverer",
    select_delivery: "Select a delivery on the left",
    no_documents: "No documents",
    order_id: "Order ID",
    dlg_new_document: "New document",
    dlg_protocol_number: "Protocol number",
    dlg_debtor: "Debtor name",
    dlg_tax_id: "CPF/CNPJ",
    dlg_recipient: "Recipient",
    dlg_cpf: "ID",
    dlg_address: "Address",
    dlg_neighborhood: "Neighborhood",
    dlg_city: "City",
    dlg_state: "State",
    dlg_zip: "ZIP code",
    cep_lookup_fail: "Could not look up ZIP code",
    dlg_notary: "Notary",
    dlg_select_notary: "Select notary office",
    doc_phase: "Phase",
    doc_sector: "Sector",
    doc_sector_none: "No sector",
    dlg_create: "Create",
    doc_created: "Document created",
    doc_create_failed: "Failed to create document",
    doc_edit: "Edit document",
    doc_updated: "Document updated",
    doc_update_failed: "Failed to update document",
    dlg_edit_document: "Edit document",
    dlg_save: "Save",
    download: "Download",
    light: "Light",
    dark: "Dark",
    language: "Language",
    create: "Create",
    delete: "Delete",
    confirm_delete: "Are you sure?",
    drag_drop_hint: "Drag cards between columns or click for details",
    canceled_move_blocked: "Canceled intimation. Only an administrator can move it to another column.",
    click_for_details: "Click for details",
    no_data: "No data for this filter.",
    new_route: "New route",
    assign_deliverer: "Assign deliverer",
    docs_deliverer_link: "Deliverer link",
    docs_deliverer_all: "All links",
    docs_select_page: "Select page",
    docs_select_filtered: "Select filtered",
    docs_clear_selection: "Clear selection",
    docs_selected_count: "{n} selected",
    docs_link_selected: "Link selected",
    docs_link_ok: "Link updated",
    deliverer_assigned_ok: "Deliverer linked to document",
    bipagem_assign_title: "Assign deliverer",
    bipagem_assign_desc: "Choose the sector, then the deliverer. Change the selection for the next batch.",
    bipagem_select_first: "Select a deliverer before scanning.",
    bipagem_now_scanning: "Scans from now on go to",
    bipagem_now_sector: "Session sector:",
    bipagem_intro: "Choose the sector, then the deliverer. With no sector, the list shows every deliverer.",
    bipagem_session_sector: "Session sector",
    bipagem_sector_all: "No sector: every deliverer. Unassigned stays available.",
    bipagem_sector_filtered: "Deliverers in {name}. Unassigned stays available.",
    bipagem_assign_confirm: "Assign deliverer",
    bipagem_assign_ok: "Deliverer assigned",
    bipagem_session_deliverer: "Session deliverer",
    bipagem_no_session_deliverer: "No deliverer set",
    bipagem_list_count: "Objects in this batch",
    bipagem_change_deliverer: "Change deliverer",
    bipagem_just_scanned: "Scanned document",
    bipagem_fix_deliverer: "Fix deliverer",
    bipagem_fix_selected: "Fix selected",
    bipagem_fix_ok: "Deliverer corrected",
    bipagem_fix_none: "Select at least one scan to correct",
    deliverer_assign_fail: "Failed to assign deliverer",
    region: "Region",
    distance: "Distance",
    estimated_time: "ETA",
    photos: "Photos",
    signatures: "Signatures",
    ar_documents: "AR docs",
    receipts: "Receipts",
    geolocation: "Geolocation",
    by_period: "By period",
    by_deliverer: "By deliverer",
    by_document: "By document",
    report_documents: "Documents",
    report_finance: "Financial",
    report_commissions: "Commissions",
    report_audit: "Audit",
    report_choose_area: "Choose the area",
    report_choose_report: "Choose the report",
    report_area_operation: "Operations",
    report_area_operation_desc: "Daily position, occurrences and returns.",
    report_area_management: "Management",
    report_area_management_desc: "Production, productivity, cycle and goals.",
    report_area_finance: "Finance",
    report_area_finance_desc: "Commissions, accounts and service orders.",
    report_area_legal: "Legal",
    report_area_legal_desc: "Proof of delivery and audit trail.",
    report_operational_position: "Operational position",
    report_operational_position_desc: "Status, aging and stalled documents.",
    report_occurrences: "Occurrences",
    report_occurrences_desc: "Delivered, attempted and returned in the period.",
    report_returns: "Returns by reason",
    report_returns_desc: "Return reasons by city and notary.",
    report_production: "Production by notary",
    report_production_desc: "Imported, delivered and returned volume.",
    report_productivity: "Deliverer productivity",
    report_productivity_desc: "Ranking, success rate and volume.",
    report_sla: "Cycle and SLA",
    report_sla_desc: "Time from received to delivered by city.",
    report_goals: "Goals vs actual",
    report_goals_desc: "Goal attainment in the period.",
    report_commission_closing: "Commission closing",
    report_commission_closing_desc: "Monthly payroll by deliverer and city.",
    report_finance_aging: "Receivables and payables",
    report_finance_aging_desc: "Overdue, upcoming and by party.",
    report_service_orders: "Service orders",
    report_service_orders_desc: "Orders by driver, km, amount and status.",
    report_evidence_coverage: "Proof of delivery",
    report_evidence_coverage_desc: "Evidence, GPS and deliveries without proof.",
    report_audit_trail: "Audit",
    report_audit_trail_desc: "Immutable trail of critical actions.",
    report_page_subtitle: "Choose the area, the report and export as CSV, Excel or PDF.",
    report_generation_pending: "Generation for this report will be enabled in the next step.",
    generate: "Generate",
    users_subtitle: "Create, edit and bulk-update users. Link deliverers to an operator and notary offices to operators.",
    users_new: "New user",
    users_role: "Role",
    users_status: "Status",
    users_active: "Active",
    users_inactive: "Inactive",
    users_empty: "No users yet",
    users_selected: "{count} selected",
    users_bulk_role: "Change role",
    users_select_role: "Select role",
    users_apply_role: "Apply role",
    users_activate: "Activate selected",
    users_deactivate: "Deactivate selected",
    users_clear_selection: "Clear selection",
    users_you: "you",
    users_created: "User created",
    users_create_failed: "Failed to create user",
    users_bulk_updated: "{count} user(s) updated",
    users_bulk_failed: "Bulk update failed",
    users_select_tenant: "Select tenant",
    users_tenants: "Notary offices",
    users_select_tenants: "Select one or more notary offices",
    users_operator: "Operator",
    users_select_operator: "Select operator",
    users_no_operators: "Create an operator before linking the deliverer",
    users_create_btn: "Create user",
    users_edit: "Edit user",
    users_save: "Save changes",
    users_updated: "User updated",
    users_update_failed: "Failed to update user",
    users_password_optional: "Leave blank to keep current password",
    users_password_required: "Password is required for new users",
    users_bulk_apply: "Apply changes",
    users_bulk_nothing: "Select at least one field to change",
    users_keep: "Keep",
    tenants_subtitle: "Each notary office operates in isolation.",
    tenants_new: "New notary office",
    tenants_edit: "Edit notary office",
    tenants_create_btn: "Create notary office",
    tenants_contact_email: "Contact email",
    tenants_city_hint: "Used to auto-assign the notary office during import",
    tenants_created: "Notary office created",
    tenants_updated: "Notary office updated",
    tenants_create_failed: "Failed to create notary office",
    tenants_update_failed: "Failed to update notary office",
    sectors_subtitle: "Each notary office has its own sectors. Sector names are free text; notaries and deliverers come from existing records.",
    sectors_new: "New sector",
    sectors_add: "Add sector",
    sectors_edit: "Edit sector",
    sectors_create_btn: "Create sector",
    sectors_name: "Sector name",
    sectors_name_placeholder: "E.g. Downtown, Morada do Sol",
    sectors_deliverers: "Deliverers",
    sectors_filter_deliverers: "Search deliverer",
    sectors_deliverer_hint: "The same deliverer can belong to more than one sector.",
    sectors_selected: "{count} selected",
    sectors_no_deliverers: "No deliverers yet. Create them in Users.",
    sectors_no_tenants: "No notary offices yet. Create them in Tenants.",
    sectors_empty: "No sectors in this notary office.",
    sectors_created: "Sector created",
    sectors_updated: "Sector updated",
    sectors_deleted: "Sector deleted",
    sectors_save_failed: "Failed to save sector",
    sectors_delete: "Delete",
    sectors_delete_title: "Delete sector",
    sectors_delete_desc: "Deliverer links for this sector will be removed as well.",
    sectors_search: "Search notary, sector, or deliverer",
    sectors_count: "{count} sector(s)",
    sectors_none_linked: "No deliverers linked",
    sectors_no_match: "No results",
    loading: "Loading...",
    saving: "Saving...",
    so_subtitle: "Freight Transport Service Order registration",
    so_title_transport: "Freight Transport Service Order",
    so_section_order: "Service Order Data",
    so_section_service: "Executed Service Data",
    so_section_complement: "Additional Data",
    so_numero_os: "SO Number:",
    so_numero_os_auto: "Auto-generated on save",
    so_datetime: "Service Date & Time:",
    so_cliente_pagador: "Paying client:",
    so_cliente_tax_id: "Client CPF/CNPJ:",
    so_coleta: "Pickup Address {n}:",
    so_coleta01: "Pickup Address 01:",
    so_coleta02: "Pickup Address 02:",
    so_coleta03: "Pickup Address 03:",
    so_add_coleta: "Add pickup address",
    so_remove_coleta: "Remove pickup address",
    so_mercadoria: "Goods:",
    so_entrega: "Delivery Address {n}:",
    so_add_entrega: "Add delivery address",
    so_remove_entrega: "Remove delivery address",
    so_km_inicial: "Initial km:",
    so_km_final: "Final km:",
    so_km_total: "Total km:",
    so_valor_frete: "Freight Value:",
    so_valor_frete_admin: "Calculated automatically",
    so_valor_frete_only_admin: "Only the administrator can change this value",
    so_placa: "Vehicle Plate:",
    so_motorista: "Driver Name:",
    so_observacoes: "Observations",
    so_save: "Save service order",
    so_new: "New SO",
    so_select: "Select SO",
    so_created: "Service order created",
    so_updated: "Service order updated",
    so_deliverer: "Deliverer:",
    so_deliverer_select: "Select deliverer",
    so_deliverer_none: "Unassigned",
    so_created_pending: "Order submitted for administrator approval",
    so_deliverer_pending_msg: "This order was submitted and can no longer be edited. Wait for the administrator to set the freight value and approve.",
    so_history_title: "Service Order History",
    so_history_empty: "No service orders found",
    so_filter_all: "All statuses",
    so_status_pendente_aprovacao: "Pending approval",
    so_status_aprovada: "Approved",
    so_status_cancelada: "Cancelled",
    so_approve: "Submit and Approve",
    so_approved: "Order approved and added to Accounts Receivable",
    so_frete_required: "Enter the freight value",
    so_export_ok: "Export completed",
    so_timeline: "Order timeline",
    so_action_criada: "Created",
    so_action_editada: "Edited by administrator",
    so_action_aprovada: "Approved",
    role_admin: "Administrator",
    role_operator: "Operator",
    role_deliverer: "Deliverer",
    role_client: "Client",
  },
};

const TIMELINE_NOTE_STATIC = {
  "Código de barras desvinculado": "timeline_note_barcode_unlink",
  "Documento recebido": "timeline_note_received",
  "Entregador vinculado": "timeline_note_deliverer_linked",
  "Entregador desvinculado": "timeline_note_deliverer_unlinked",
  "Documento recebido (seed)": "timeline_note_received_seed",
  "Importado via CSV": "timeline_note_csv",
  "Importado (homologado)": "timeline_note_homologated",
  "Intimação recebida": "timeline_note_intimacao",
  "Homologação rejeitada": "timeline_note_homologation_rejected",
  "Entregador vinculado": "timeline_note_deliverer_linked",
  "Associação manual": "timeline_note_manual_assoc",
  "Entrega concluída": "timeline_note_delivery_done",
  "Destinatário ausente": "timeline_note_absent",
  "Entregador vinculado": "timeline_note_deliverer_linked",
};

const TIMELINE_PREFIX = {
  status: "status",
  outcome: "outcome",
  evidence: "evidence_kind",
  audit: "audit_action",
  audit_module: "audit_mod",
};

export function translateTimeline(t, kind, value) {
  if (kind === "note") {
    if (!value) return "";
    const staticKey = TIMELINE_NOTE_STATIC[value];
    if (staticKey) return t(staticKey);

    const barcodeLinked = value.match(/^Código de barras vinculado(?::\s*(.+))?$/i);
    if (barcodeLinked) {
      return barcodeLinked[1]
        ? `${t("timeline_note_barcode_link")}: ${barcodeLinked[1]}`
        : t("timeline_note_barcode_link");
    }

    const statusChanged = value.match(/^Status alterado para (.+)$/i);
    if (statusChanged) {
      return t("timeline_note_status_changed").replace("{status}", translateTimeline(t, "status", statusChanged[1].trim()));
    }

    const occurrence = value.match(/^Ocorr[eê]ncia:\s*(.+)$/i);
    if (occurrence) {
      return t("timeline_note_occurrence").replace("{outcome}", translateTimeline(t, "outcome", occurrence[1].trim()));
    }

    const merged = value.match(/^Unificado no documento (.+)$/i);
    if (merged) {
      return t("timeline_note_merged").replace("{label}", merged[1]);
    }

    return value;
  }

  if (!value) return "—";
  const prefix = TIMELINE_PREFIX[kind] || kind;
  const key = `${prefix}_${value}`;
  const label = t(key);
  return label !== key ? label : value;
}

const I18nContext = createContext({ lang: "pt", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("nafe_lang") || "pt");
  useEffect(() => { localStorage.setItem("nafe_lang", lang); }, [lang]);
  const t = useCallback((k) => dict[lang]?.[k] || dict.pt[k] || k, [lang]);
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
